// extracted by mini-css-extract-plugin
export default {"element":"HorseBox_element__nbAm2"};